<template>
  <component
    :is="tagName"
    v-bind="tagProps"
    class="menu-item"
    :class="{'disabled': disabled, 'not-click': !hasClick, 'small': small}"
    :data-qa="dataQa"
    :style="styleItem"
    v-on="handlers">
    <slot name="before-icon"/>
    <sIcon
      v-if="icon"
      :class="['menu-item-icon', iconClass]"
      :color="iconColor"
      :data-qa="`${dataQa}-icon`"
      :size="small ? '15' : '16'"
      :type="icon"/>
    <div
      class="menu-item-label"
      :data-qa="`${dataQa}-label`">
      <slot name="content">
        {{ label }}
        <slot name="after"/>
      </slot>
    </div>
  </component>
</template>
<script>
export default {
  name: 'menuItem',
  inheritAttrs: false,
  methods: {
    /**
     * Копирует все атрибуты из $attrs (например, target, rel, download и др.)
     */
    getTagProps(tag, baseProps) {
      const attrs = this.$attrs || {}
      return { ...baseProps, ...attrs }
    },
    sendClick(e) {
      if (this.disabled) {
        return
      }
      this.$emit('click', e)
    }
  },
  computed: {
    styleItem() {
      let height = '40px'
      if (this.height && typeof this.height === 'string') {
        height = this.height
      } else if (this.height && typeof this.height === 'number') {
        height = `${this.height}px`
      } else {
        height = '40px'
      }
      return `height: ${height}`
    },
    handlers() {
      if (this.to) {
        return {
          'clickNative': (e) => { this.sendClick(e) },
          'beforeEnter': (e) => { this.sendClick(e) }
        }
      }
      return {
        click: (e) => { this.sendClick(e) },
      }
    },
    tagName() {
      if (this.href) {
        return 'a'
      } else if (this.to) {
        return 'router-link'
      }
      return 'div'
    },
    tagProps() {
      if (this.tagName === 'router-link') {
        if (this.disabled) { return { to: {} } }
        return this.getTagProps('router-link', { to: this.to, exactActiveClass: 'opacity-7' })
      }
      if (this.tagName === 'a') {
        if (this.disabled) { return {} }
        return this.getTagProps('a', { href: this.href })
      }
      // div
      return {}
    },
    hasClick() {
      if (this.text) {
        return false
      }
      if (this.tagName === 'a' && !this.href) {
        return false
      }
      if (this.tagName === 'router-link' && !this.to) {
        return false
      }
      return true
    }
  },
  props: {
    /**
     * Текст пункта меню
     */
    label: {
      type: String
    },
    /**
     * Иконка
     */
    icon: {
      type: String
    },
    /**
     * Цвет иконки
     */
    iconColor: {
      type: String,
      default: 'var(--black-color)'
    },
    /**
     * Доп. класс иконки
     */
    iconClass: {
      type: String,
    },
    /**
     * Не активный пункт меню
     */
    disabled: {
      type: Boolean
    },
    height: {
      type: [Number, String],
      default: 40
    },
    href: {
      type: String,
    },
    to: {
      type: Object,
    },
    /** Без клика, если div*/
    text: {
      type: Boolean
    },
    /** компактный режим. В частности, выпадалка в пункте меню Тендеры */
    small: {
      type: Boolean
    },
    dataQa: {
      type: String,
      default: 'menu-item'
    },
  },
}
</script>
<style scoped lang="scss">
.menu-item {
  color: var(--black-color);
  display: flex;
  font-size: 14px;
  text-align: left;
  transition: 0.25s all;
  .router-link-exact-active {
    color: var(--v-secondary__green_not_active-base);
    caret-color: var(--v-secondary__green_not_active-base);
  }
  &.small {
    font-size: 13px;
    .menu-item-label {
      margin-left: 10px;
    }
  }
  &:not(.not-click) {
    cursor: pointer;
  }
  &.disabled {
    cursor: default;
    opacity: 0.5;
  }
  &:not(.router-link-exact-active):not(.disabled):not(.not-click):hover,
  &:not(.router-link-exact-active):not(.disabled):not(.not-click):focus {
    background: var(--color-main-green);
  }
  &-icon {
    margin: auto 0 auto 15px;
  }
  &-label{
    width: 100%;
    margin: auto 10px auto 15px;
    line-height: 16px;
    color: var(--black-color);
  }
}
</style>
